<template>
	<div class="post">
		<div class="body">
		<!--	<div class="cover" :style="{'background-image': `url(${coverUrl})`}"></div> -->
			<div class="cross">
				<router-link class="link" to="../posts/#eximusblog">
				<img :src="require('@/assets/cross.png')"/>
				</router-link>
			</div>
			
			<div class="text">
				<div class="date">{{ post.date | moment('D MMM Y') }}, {{ authorName }}</div>
				<h1 v-html="title" class="title"></h1>
				<div class="content rendered" v-html="content"></div>
				<div class="authorbio">
					<div class="avatar">
						<img :src="authorAvatar">
					</div>
					<div class="bio">
						<h4 class="titlebio">Scritto da {{ authorName }}</h4>
						<p v-html="authorBio" class="description"></p>
					</div>
				</div>
				<div class="contbuttonblog">
					<router-link class="link" to="../posts/#eximusblog">
					<button type="button" class="buttonblog">Torna al Blog</button>
					</router-link>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import {notif} from '@/pop'
import {Post} from '@/plugins/api'

export default {
	name: 'post',

	data() {

		return {
			post: null
		}
	},

	computed: {
		/**
		 * 
		 */
		coverUrl() {

			return this.post ? this.post._embedded['wp:featuredmedia'][0].source_url : 'none'
		},

		/**
		 * 
		 */
		authorName() {

			return this.post ? this.post._embedded.author[0].name : 'Autore'
		},

		/**
		 * 
		 */
		authorAvatar() {

			return this.post ? this.post._embedded.author[0].simple_local_avatar.full : 'none'
		},

		/**
		 * 
		 */
		authorBio() {

			return this.post ? this.post._embedded.author[0].description : 'none'
		},

		/**
		 * 
		 */
		title() {

			return this.post ? this.post.title.rendered : 'Article'
		},

		/**
		 * 
		 */
		content() {

			return this.post ? this.post.content.rendered : null
		}
	},

	mounted() {

		window.scrollTo(0, 0)
	},

	async beforeRouteEnter(to, from, next) {

		try
		{
			// Fetch post
			let post = (await Post.getBySlug(to.params.slug, {_embed: 1}))[0] || null

			if (post) next((vm) => vm.post = post)
			else
			{
				notif.error('il post richiesto non esiste')
				next(from)
			}
		}
		catch (e)
		{
			/* notif.error(e) */
			console.error(e)

			// Go back
			next(from)
		}
	}
}
</script>

<style lang="stylus" scoped>
.contbuttonblog
	position relative
	width 240px
	margin 0 auto
	padding-top 0
	padding-bottom 1.5em

	@media (max-width: unit(768, px))
		padding-top 0

	.buttonblog
		border 3px solid #dcdcdc
		color #dcdcdc
		padding 20px 40px
		width 100%
		background #101418
		border-radius 50px
		cursor pointer
		transition 0.2s ease
		font-size 1.1em
		font-weight bold
		text-transform uppercase

	.buttonblog:hover
			color #101418
			background #dcdcdc

.authorbio
	display flex
	padding 40px 40px
		
	@media (max-width: unit(media-phone-max, px))
		display block

.avatar
	margin-right 20px

	@media (max-width: unit(media-phone-max, px))
		margin 0


.avatar img
	max-width 4em
	border-radius 2em

	@media (max-width: unit(media-phone-max, px))
		display block
		margin 0 auto

.bio 
	flex 1
	
.titlebio
	margin 0 0 1em

	@media (max-width: unit(media-phone-max, px))
		text-align center
		margin-top 5px

.cross
	position fixed
	right 20px
	margin-top 20px
	cursor pointer
	transition 0.4s ease
	z-index 9999

.cross img 
	width 1.4em

.body
	max-width 800px

	margin auto

	.cover
		position relative

		background-size cover
		background-position center

		&:after
			content ''

			display block
		
			position relative

			padding-bottom 50%
	
	.text
		padding 1em

		.date
			color lightish
			
			font-weight bold
			
		.title
			color primary

			font-size 3em
			font-weight bold

			&:before
				

				display inline-block

				margin-right 0.5em

				font-size 1.2em
</style>

<style lang="stylus">
blockquote
	text-align left
	padding 1em
	font-weight 400

blockquote:before 
	content url('../assets/quotes.png')
	display inline-block

h4
	text-transform uppercase

.rendered
	&.content
		font-size 1.2em
		font-weight 300
		line-height 1.7

		img
			max-width 400px

			@media (max-width: unit(769, px))
				max-width 100%
		a
			color secondary
		figure
			figcaption
				font-size 0.8em
				font-style italic

.blocks-gallery-grid
	list-style-type none
	display grid
	grid-template-columns repeat(4, 1fr)
	grid-gap 1em
	padding 0
	margin-top 3em

	@media (max-width: unit(766, px))
		grid-template-columns repeat(2, 1fr)
	
	.blocks-gallery-item

		figure 
			margin 0

.wp-block-gallery 
	margin 0
	
.wp-block-image img 
	display block
	margin auto
	height 100%
	width 100%
</style>